import cx from 'classnames';
import {ReactNode} from 'react';
import {Button} from '~library/atoms/Button';

import './IconWithBadge.sass';

interface IconWithBadgeProps {
  className?: string;
  'data-qa-id'?: string;
  mainIcon: ReactNode | null;
  badgeIcon: ReactNode | null;
  disabled?: boolean;
}

export const IconWithBadge = ({
  className = '',
  'data-qa-id': dataQaId = 'icon-with-badge-button',
  mainIcon = null,
  badgeIcon = null,
  disabled = false,
}: IconWithBadgeProps) => (
  <div className="icon-with-badge__container">
    <Button
      variant="transparent"
      disabled={disabled}
      data-qa-id={dataQaId}
      className={cx('icon-with-badge__button', className)}
    >
      {mainIcon}
    </Button>
    {badgeIcon && (
      <div
        className={cx('icon-with-badge__badge-icon', {
          'icon-width-badge__badge-icon__disabled': disabled,
        })}
      >
        {badgeIcon}
      </div>
    )}
  </div>
);
